/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type reconciliation_SubsidyLedgerCashInDTO = {
    amountCents?: number;
    applicationId?: string;
    appliedAt?: string;
    counterpartPaymentId?: string;
    /**
     * Kind is cash_in or office_reclaim_out (issue #1576). An
     * office_reclaim_out row carries a negative AmountCents and the TARGET
     * payment's received date, and CounterpartPaymentID names that target.
     */
    kind: reconciliation_SubsidyLedgerCashInDTO.kind;
    paymentId?: string;
    paymentStatus?: string;
    receivedDate?: string;
    source?: string;
};
export namespace reconciliation_SubsidyLedgerCashInDTO {
    /**
     * Kind is cash_in or office_reclaim_out (issue #1576). An
     * office_reclaim_out row carries a negative AmountCents and the TARGET
     * payment's received date, and CounterpartPaymentID names that target.
     */
    export enum kind {
        CASH_IN = 'cash_in',
        OFFICE_RECLAIM_OUT = 'office_reclaim_out',
    }
}

